import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToastModule } from 'primeng/toast';
import { AddressModule } from '../../../address/address.module';
import { CustomerAffiliationModule } from '../../../customer/affiliation/customer-affiliation.module';
import { CustomerAttributesModule } from '../../../customer/attributes/customer-attributes.module';
import { AuthorizedPresenceModule } from '../../../customer/authorized-presence/authorized-presence.module';
import { CustomerContactModule } from '../../../customer/contacts/customer-contact.module';
import { CustomerPhotoCaptureModalComponent } from '../../../customer/customer-photo-capture/customer-photo-capture-modal.component';
import { IndividualCustomerDetailsModule } from '../../../customer/detail/individual/individual-customer-details.module';
import { CustomerIdentificationModule } from '../../../customer/identification/customer-identification.module';
import { CustomerImageModule } from '../../../customer/image/customer-image.module';
import { CustomerNamesModule } from '../../../customer/name/customer-names.module';
import { PhotoFirstModalComponent } from '../../../customer/photo-first/customer-photo-first-modal.component';
import { ValidationResultsModule } from '../../../shared/components/validation-results/validation-results.module';
import { MaterialModule } from '../../../shared/material.module';
import { MVMSpinnerBtnModule } from '../../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedModule } from '../../../shared/shared.module';
import { SharedValidatorsModule } from '../../../shared/validators/shared-validators.module';
import { CurrentCredentialViewModalComponent } from '../../credential/issuance/credential/current-credential-modal.component';
import { OOJCredentialViewModalComponent } from '../../credential/issuance/credential/ooj-credential-modal.component';
import { DriverCoreModule } from '../../driver-core.module';
import { DriverSharedModule } from '../../driver-shared.module';
import { OneTimeMailingAddressModule } from '../shared/one-time-mailing-address/one-time-mailing-address.module';
import { CustomerDetailComponent } from './customer-detail.component';

@NgModule({
    declarations: [
        CurrentCredentialViewModalComponent,
        CustomerDetailComponent,
        OOJCredentialViewModalComponent,
        PhotoFirstModalComponent,
        CustomerPhotoCaptureModalComponent
    ],
    providers: [],
    imports: [
        AddressModule,
        AuthorizedPresenceModule,
        CalendarModule,
        CommonModule,
        CustomerAffiliationModule,
        CustomerAttributesModule,
        CustomerContactModule,
        CustomerIdentificationModule,
        CustomerImageModule,
        CustomerNamesModule,
        DriverCoreModule,
        DriverSharedModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        IndividualCustomerDetailsModule,
        MaterialModule,
        MaterialModule.forRoot(),
        MultiSelectModule,
        MVMSpinnerBtnModule,
        OneTimeMailingAddressModule,
        ReactiveFormsModule,
        RouterModule,
        SharedValidatorsModule,
        SharedModule,
        ToastModule,
        ValidationResultsModule
    ],
    exports: [
        CustomerDetailComponent
    ]
})
export class CustomerDetailModule {
}
